import { useRef } from 'react';
import { PubSubService } from '@vivli/shared/infrastructure/service';
import { useAppConfigContext, useAuthServiceContext } from '@vivli/core/infrastructure/context';

// DEV-1103: builds the one PubSubService a pub/sub hook uses. The Ably token endpoint requires a signed-in
// user, so the service is handed a token getter. The latest getTokenSilent is kept in a ref, so a service
// built once never calls a stale getter when Ably renews its token.
export const usePubSubService = () => {
    const config = useAppConfigContext();
    const { getTokenSilent } = useAuthServiceContext();

    const getTokenRef = useRef(getTokenSilent);
    getTokenRef.current = getTokenSilent;

    const pubSubService = useRef<PubSubService>(null);
    if (!pubSubService.current) {
        pubSubService.current = new PubSubService(config.aspNetCoreEnvironment, config.apiUri, () => getTokenRef.current());
    }

    return pubSubService;
};
